import React from 'react'
import { useTranslation } from 'react-i18next'
import Gender from 'enums/Gender'
import LevelOneType from 'enums/LevelOneType'
import { WidgetGuard } from 'features/types'
import { SocialWebStoryScopeWidget } from 'schemas/SocialWebStoryScopeWidgetSchema'
import ErrorMessage from 'components/share/ErrorMessage'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'

const isGenderFilterContradictory = (widgetSetting: SocialWebStoryScopeWidget) =>
  widgetSetting.levelOneType === LevelOneType.GENDER_WO_UNKNOWN &&
  widgetSetting?.genders?.length === 1 &&
  widgetSetting?.genders?.[0] === Gender.UNKNOWN

const FilterContradictoryGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebStoryScopeWidget>(widgetId)
  const { t } = useTranslation()

  if (isGenderFilterContradictory(widgetSetting)) {
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  }

  return children
}

export default FilterContradictoryGuard
